import { withSentryRouting } from "@sentry/react";
/* eslint-disable no-restricted-imports */
import type { LocationDescriptor } from "history";
import { Route } from "react-router-dom";
import {
  NavLink,
  Link,
  useMatch,
  Navigate,
  useNavigate,
  matchPath,
} from "react-router-dom-v5-compat";

const SentryRoute = withSentryRouting(Route);

/* eslint-disable import/export */
export * from "react-router-dom";
export {
  SentryRoute as Route,
  NavLink,
  Link,
  useMatch,
  useNavigate,
  Navigate,
  matchPath,
  type LocationDescriptor as To,
};
